(function () {
  "use strict";
  var KLAVIYO_CLIENT_REVISION = "2026-01-15";

  function isValidEmail(value) {
    if (!value) {
      return false;
    }

    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim());
  }

  function getSubmitButton(form) {
    return form.querySelector('button[type="submit"]');
  }

  function setSubmitState(form, submitting) {
    var button = getSubmitButton(form);
    if (!button) {
      return;
    }

    if (!button.dataset.originalText) {
      button.dataset.originalText = button.textContent || "";
    }

    if (submitting) {
      button.disabled = true;
      button.textContent = "Submitting...";
      form.classList.add("is-submitting");
      return;
    }

    button.disabled = false;
    button.textContent = button.dataset.originalText;
    form.classList.remove("is-submitting");
  }

  function showClientError(form, message) {
    var errorEl = form.querySelector("[data-client-error]");
    if (!errorEl) {
      return;
    }

    if (message) {
      errorEl.textContent = message;
      errorEl.hidden = false;
      return;
    }

    errorEl.textContent = "";
    errorEl.hidden = true;
  }

  function readHiddenFieldValue(form, selector) {
    var input = form.querySelector(selector);
    if (!(input instanceof HTMLInputElement)) {
      return "";
    }

    return (input.value || "").trim();
  }

  function inferKlaviyoPublicApiKey() {
    var scriptEls = document.querySelectorAll('script[src*="klaviyo"]');
    var queryPattern = /(?:\?|&)company_id=([^&]+)/i;
    var pathPattern = /\/onsite\/js\/([^/]+)\/klaviyo(?:\.js)?(?:[?#]|$)/i;

    for (var i = 0; i < scriptEls.length; i += 1) {
      var src = scriptEls[i] && scriptEls[i].src ? scriptEls[i].src : "";
      if (!src) {
        continue;
      }

      var queryMatch = src.match(queryPattern);
      if (queryMatch && queryMatch[1]) {
        return decodeURIComponent(queryMatch[1]).trim();
      }

      var pathMatch = src.match(pathPattern);
      if (pathMatch && pathMatch[1]) {
        return decodeURIComponent(pathMatch[1]).trim();
      }
    }

    return "";
  }

  function getKlaviyoSubscriptionConfig(form) {
    var listId = readHiddenFieldValue(form, "[data-klaviyo-waitlist-list-id]");
    if (!listId) {
      return null;
    }

    var publicApiKey = readHiddenFieldValue(form, "[data-klaviyo-public-api-key]") || inferKlaviyoPublicApiKey();
    if (!publicApiKey) {
      return null;
    }

    return {
      listId: listId,
      publicApiKey: publicApiKey
    };
  }

  function subscribeEmailToKlaviyoWaitlist(form, email) {
    if (typeof window.fetch !== "function") {
      return;
    }

    var config = getKlaviyoSubscriptionConfig(form);
    if (!config) {
      return;
    }

    var payload = {
      data: {
        type: "subscription",
        attributes: {
          custom_source: "Launch waitlist form",
          profile: {
            data: {
              type: "profile",
              attributes: {
                email: email.trim(),
                subscriptions: {
                  email: {
                    marketing: {
                      consent: "SUBSCRIBED"
                    }
                  }
                }
              }
            }
          }
        },
        relationships: {
          list: {
            data: {
              type: "list",
              id: config.listId
            }
          }
        }
      }
    };

    fetch("https://a.klaviyo.com/client/subscriptions?company_id=" + encodeURIComponent(config.publicApiKey), {
      method: "POST",
      headers: {
        Accept: "application/vnd.api+json",
        "Content-Type": "application/vnd.api+json",
        revision: KLAVIYO_CLIENT_REVISION
      },
      body: JSON.stringify(payload),
      keepalive: true
    }).catch(function () {
      // Avoid blocking the Shopify customer form submit.
    });
  }

  function initLoadingScreen() {
    var body = document.body;
    var loader = document.querySelector(".js-launch-loader");
    if (!(body instanceof HTMLElement) || !(loader instanceof HTMLElement)) {
      return;
    }

    var hasScheduled = false;
    var hasCompleted = false;
    var startTime = Date.now();
    var minVisibleMs = 550;
    var maxWaitMs = 2800;

    function completeLoader() {
      if (hasCompleted) {
        return;
      }

      hasCompleted = true;
      body.classList.add("is-loading-complete");
      body.classList.remove("is-loading");

      if (typeof window.dispatchEvent === "function") {
        var loaderCompleteEvent;
        if (typeof window.CustomEvent === "function") {
          loaderCompleteEvent = new CustomEvent("launch:loader-complete");
        } else {
          loaderCompleteEvent = document.createEvent("Event");
          loaderCompleteEvent.initEvent("launch:loader-complete", true, true);
        }
        window.dispatchEvent(loaderCompleteEvent);
      }

      window.setTimeout(function () {
        loader.hidden = true;
      }, 1200);
    }

    function scheduleCompletion() {
      if (hasScheduled) {
        return;
      }

      hasScheduled = true;
      var elapsed = Date.now() - startTime;
      var remaining = Math.max(0, minVisibleMs - elapsed);

      window.setTimeout(completeLoader, remaining);
    }

    if (document.readyState === "complete") {
      scheduleCompletion();
    } else {
      window.addEventListener("load", scheduleCompletion, { once: true });
    }

    // Fallback in case the load event is delayed.
    window.setTimeout(scheduleCompletion, maxWaitMs);
  }

  function clamp(value, min, max) {
    if (value < min) {
      return min;
    }
    if (value > max) {
      return max;
    }
    return value;
  }

  var revealObserver = null;
  var activeSocialProofModal = null;
  var activeSocialProofTrigger = null;
  var activeFlavorsFactsModal = null;
  var activeFlavorsFactsTrigger = null;

  function syncLaunchModalBodyLock() {
    if (activeSocialProofModal instanceof HTMLElement || activeFlavorsFactsModal instanceof HTMLElement) {
      document.body.classList.add("launch-modal-open");
      document.documentElement.classList.add("launch-modal-open");
      return;
    }
    document.body.classList.remove("launch-modal-open");
    document.documentElement.classList.remove("launch-modal-open");
  }

  function shouldReduceMotion() {
    return window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }

  function isGlassEffectElement(element) {
    if (!(element instanceof HTMLElement)) {
      return false;
    }

    if (
      element.matches(".launch-hero__email-glass, .launch-flavors__stat, .launch-flavors__stats, .glassContainer, .glassContainer-blur")
    ) {
      return true;
    }

    return !!element.closest(".launch-hero__email-glass, .launch-flavors__stat, .launch-flavors__stats, .glassContainer");
  }

  function markRevealElement(element, delayMs, isHero) {
    if (!(element instanceof HTMLElement)) {
      return;
    }

    if (element.dataset.revealBound === "true") {
      return;
    }

    if (isGlassEffectElement(element)) {
      return;
    }

    element.dataset.revealBound = "true";
    element.classList.add("launch-reveal");

    if (isHero) {
      element.classList.add("launch-reveal--hero");
    }

    if (typeof delayMs === "number" && delayMs > 0) {
      element.style.setProperty("--launch-reveal-delay", delayMs + "ms");
    } else {
      element.style.setProperty("--launch-reveal-delay", "0ms");
    }
  }

  function ensureRevealObserver() {
    if (revealObserver || !("IntersectionObserver" in window)) {
      return;
    }

    revealObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting && entry.intersectionRatio < 0.15) {
            return;
          }

          var target = entry.target;
          if (target instanceof HTMLElement) {
            target.classList.add("is-revealed");
          }
          revealObserver.unobserve(entry.target);
        });
      },
      {
        root: null,
        rootMargin: "0px 0px -12% 0px",
        threshold: 0.15
      }
    );
  }

  function observeRevealElement(element) {
    if (!(element instanceof HTMLElement)) {
      return;
    }

    if (element.classList.contains("is-revealed")) {
      return;
    }

    if (shouldReduceMotion()) {
      element.classList.add("is-revealed");
      return;
    }

    ensureRevealObserver();

    if (!revealObserver) {
      element.classList.add("is-revealed");
      return;
    }

    revealObserver.observe(element);
  }

  function initViewportReveals(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;

    var heroTargets = root.querySelectorAll(
      ".launch-hero__brand, .launch-hero__bag-stack, .launch-hero__title, .launch-hero__body, .launch-hero__divider"
    );
    for (var i = 0; i < heroTargets.length; i += 1) {
      markRevealElement(heroTargets[i], i * 70, true);
      observeRevealElement(heroTargets[i]);
      if (heroTargets[i] instanceof HTMLElement) {
        (function (target, delayMs) {
          window.setTimeout(function () {
            if (!target.isConnected || target.classList.contains("is-revealed")) {
              return;
            }
            target.classList.add("is-revealed");
          }, delayMs);
        })(heroTargets[i], 900 + i * 70);
      }
    }

    var standardTargets = root.querySelectorAll(
      ".launch-social-proof__title, .launch-social-proof__cta, .launch-flavors__title, .launch-flavors__body, .launch-flavors__availability, .launch-flavors__stage-heading, .launch-flavors__stage-subheading, .launch-flavors__stage-summary, .launch-flavors__card"
    );
    for (var j = 0; j < standardTargets.length; j += 1) {
      markRevealElement(standardTargets[j], 0, false);
      observeRevealElement(standardTargets[j]);
    }

    var footerTargets = root.querySelectorAll(".launch-footer__tagline, .launch-footer__links, .launch-footer__copyright");
    for (var f = 0; f < footerTargets.length; f += 1) {
      footerTargets[f].classList.remove("launch-reveal", "launch-reveal--hero", "is-revealed");
      footerTargets[f].style.removeProperty("--launch-reveal-delay");
      if (footerTargets[f].dataset) {
        delete footerTargets[f].dataset.revealBound;
      }
    }

    var socialCards = root.querySelectorAll(".launch-social-proof__card");
    for (var k = 0; k < socialCards.length; k += 1) {
      markRevealElement(socialCards[k], k * 90, false);
      observeRevealElement(socialCards[k]);
    }

  }

  function bindHeroOceanScroll(heroSection) {
    if (!(heroSection instanceof HTMLElement)) {
      return;
    }

    if (heroSection.dataset.heroOceanBound === "true") {
      return;
    }

    var ocean = heroSection.querySelector(".js-launch-hero-ocean");
    if (!(ocean instanceof HTMLElement)) {
      return;
    }

    heroSection.dataset.heroOceanBound = "true";

    var baseBottom = Number(ocean.getAttribute("data-base-bottom"));
    if (!Number.isFinite(baseBottom)) {
      baseBottom = 20;
    }

    var maxOffset = Number(ocean.getAttribute("data-scroll-offset"));
    if (!Number.isFinite(maxOffset)) {
      maxOffset = 400;
    }

    var isTicking = false;

    function updateOceanBottom() {
      isTicking = false;

      var rect = heroSection.getBoundingClientRect();
      var progress = clamp(-rect.top / Math.max(rect.height, 1), 0, 1);
      var offset = maxOffset * progress;
      ocean.style.bottom = baseBottom + offset + "px";
    }

    function scheduleUpdate() {
      if (isTicking) {
        return;
      }

      isTicking = true;
      window.requestAnimationFrame(updateOceanBottom);
    }

    window.addEventListener("scroll", scheduleUpdate, { passive: true });
    window.addEventListener("resize", scheduleUpdate);

    scheduleUpdate();
  }

  function initHeroOceanScroll(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var heroSections = root.querySelectorAll(".launch-hero");

    heroSections.forEach(function (heroSection) {
      bindHeroOceanScroll(heroSection);
    });
  }

  function bindFlavorsStaggerIntro(flavorsSection) {
    if (!(flavorsSection instanceof HTMLElement)) {
      return;
    }

    if (flavorsSection.dataset.flavorsStaggerBound === "true") {
      return;
    }

    var fruitTargets = flavorsSection.querySelectorAll(".launch-flavors__fruit-image");
    var stripTargets = [];

    var rightStrip = flavorsSection.querySelector(".launch-flavors__product-strip-wrap--right");
    var middleStrip = flavorsSection.querySelector(".launch-flavors__product-strip-wrap--middle");
    var leftStrip = flavorsSection.querySelector(".launch-flavors__product-strip-wrap--left");

    if (rightStrip instanceof HTMLElement) {
      stripTargets.push(rightStrip);
    }
    if (middleStrip instanceof HTMLElement) {
      stripTargets.push(middleStrip);
    }
    if (leftStrip instanceof HTMLElement) {
      stripTargets.push(leftStrip);
    }

    if (!fruitTargets.length && !stripTargets.length) {
      return;
    }

    flavorsSection.dataset.flavorsStaggerBound = "true";

    var allTargets = [];

    for (var i = 0; i < fruitTargets.length; i += 1) {
      var fruit = fruitTargets[i];
      if (!(fruit instanceof HTMLElement)) {
        continue;
      }
      fruit.classList.add("launch-flavors__stagger-target", "launch-flavors__stagger-target--fruit");
      fruit.style.setProperty("--launch-stagger-delay", i * 110 + "ms");
      allTargets.push(fruit);
    }

    for (var j = 0; j < stripTargets.length; j += 1) {
      var strip = stripTargets[j];
      strip.classList.add("launch-flavors__stagger-target", "launch-flavors__stagger-target--strip");
      strip.style.setProperty("--launch-stagger-delay", j * 140 + "ms");
      allTargets.push(strip);
    }

    var staggerStartDelayMs = 250;

    function activateTarget(target) {
      if (!(target instanceof HTMLElement)) {
        return;
      }

      if (target.dataset.staggerActivated === "true") {
        return;
      }

      target.dataset.staggerActivated = "true";
      window.setTimeout(function () {
        target.classList.add("is-stagger-active");
      }, staggerStartDelayMs);
    }

    if (shouldReduceMotion()) {
      allTargets.forEach(function (target) {
        if (!(target instanceof HTMLElement)) {
          return;
        }
        target.classList.add("is-stagger-active");
      });
      return;
    }

    if (!("IntersectionObserver" in window)) {
      allTargets.forEach(function (target) {
        activateTarget(target);
      });
      return;
    }

    var staggerObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting && entry.intersectionRatio < 0.18) {
            return;
          }

          activateTarget(entry.target);
          staggerObserver.unobserve(entry.target);
        });
      },
      {
        root: null,
        rootMargin: "0px 0px -8% 0px",
        threshold: 0.18
      }
    );

    allTargets.forEach(function (target) {
      staggerObserver.observe(target);
    });
  }

  function initFlavorsStaggerIntro(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;

    if (root instanceof Element && root.matches(".launch-flavors")) {
      bindFlavorsStaggerIntro(root);
    }

    var flavorsSections = root.querySelectorAll(".launch-flavors");
    flavorsSections.forEach(function (flavorsSection) {
      bindFlavorsStaggerIntro(flavorsSection);
    });
  }

  function bindFlavorsGroundScroll(flavorsSection) {
    if (!(flavorsSection instanceof HTMLElement)) {
      return;
    }

    if (flavorsSection.dataset.flavorsGroundBound === "true") {
      return;
    }
    var palmTree = flavorsSection.querySelector(".launch-flavors__bg-palms");
    if (!(palmTree instanceof HTMLElement)) {
      return;
    }

    var ground = flavorsSection.querySelector(".launch-flavors__bg-ground");
    if (!(ground instanceof HTMLElement)) {
      return;
    }

    flavorsSection.dataset.flavorsGroundBound = "true";

    var startRight = Number(ground.getAttribute("data-scroll-start-right"));
    if (!Number.isFinite(startRight)) {
      startRight = -90;
    }

    var endRight = Number(ground.getAttribute("data-scroll-end-right"));
    if (!Number.isFinite(endRight)) {
      endRight = -70;
    }

    var startPalmTree = Number(palmTree.getAttribute("data-scroll-start-right"));
    if (!Number.isFinite(startPalmTree)) {
      startPalmTree = -290;
    }
    var endPalmTree = Number(palmTree.getAttribute("data-scroll-end-right"));
    if (!Number.isFinite(endPalmTree)) {
      endPalmTree = -350;
    }
    var isTicking = false;

    function updateGroundRight() {
      isTicking = false;

      var rect = flavorsSection.getBoundingClientRect();
      var startOffset = window.innerHeight * 0.4; // starts ~25vh earlier
      var progress = clamp((startOffset - rect.top) / Math.max(rect.height, 1), 0, 1);
      var currentRight = startRight + (endRight - startRight) * progress;
      ground.style.right = currentRight.toFixed(3).replace(/\.?0+$/, "") + "%";
    }
    function updatePalmTreeRight() {
      isTicking = false;

      var rect = flavorsSection.getBoundingClientRect();
      var palmTreeOffset = window.innerHeight * 0.3; // starts ~25vh earlier
      var palmTreeProgress = clamp((palmTreeOffset - rect.top) / Math.max(rect.height, 1), 0, 1);
      var currentPalmTree = startPalmTree + (endPalmTree - startPalmTree) * palmTreeProgress;
      palmTree.style.right = currentPalmTree.toFixed(3).replace(/\.?0+$/, "") + "vw";
    }
    function scheduleUpdate() {
      if (isTicking) {
        return;
      }

      isTicking = true;
      window.requestAnimationFrame(updateGroundRight);
      window.requestAnimationFrame(updatePalmTreeRight);
    }

    window.addEventListener("scroll", scheduleUpdate, { passive: true });
    window.addEventListener("resize", scheduleUpdate);

    scheduleUpdate();
  }

  function initFlavorsGroundScroll(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    if (root instanceof Element && root.matches(".launch-flavors")) {
      bindFlavorsGroundScroll(root);
    }
    var flavorsSections = root.querySelectorAll(".launch-flavors");

    flavorsSections.forEach(function (flavorsSection) {
      bindFlavorsGroundScroll(flavorsSection);
    });
  }

  function bindFlavorsBackgroundLayout(flavorsSection) {
    if (!(flavorsSection instanceof HTMLElement)) {
      return;
    }

    var stage = flavorsSection.querySelector(".launch-flavors__stage");
    if (!(stage instanceof HTMLElement)) {
      return;
    }

    function updateBackgroundLayout() {
      var sectionRect = flavorsSection.getBoundingClientRect();
      var stageRect = stage.getBoundingClientRect();
      var topOffset = Math.max(0, stageRect.top - sectionRect.top);
      var bottomOffset = Math.max(0, sectionRect.bottom - stageRect.bottom);

      stage.style.setProperty("--launch-flavors-stage-offset-top", topOffset.toFixed(2) + "px");
      stage.style.setProperty("--launch-flavors-stage-offset-bottom", bottomOffset.toFixed(2) + "px");
    }

    if (stage.dataset.flavorsBackgroundLayoutBound === "true") {
      updateBackgroundLayout();
      return;
    }

    stage.dataset.flavorsBackgroundLayoutBound = "true";

    function scheduleUpdate() {
      window.requestAnimationFrame(updateBackgroundLayout);
    }

    window.addEventListener("resize", scheduleUpdate);
    window.addEventListener("load", scheduleUpdate);

    scheduleUpdate();
  }

  function initFlavorsBackgroundLayout(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    if (root instanceof Element && root.matches(".launch-flavors")) {
      bindFlavorsBackgroundLayout(root);
    }
    var flavorsSections = root.querySelectorAll(".launch-flavors");

    flavorsSections.forEach(function (flavorsSection) {
      bindFlavorsBackgroundLayout(flavorsSection);
    });
  }

  function bindFlavorsCursorNote(productWrap) {
    if (!(productWrap instanceof HTMLElement)) {
      return;
    }

    if (productWrap.dataset.flavorsCursorNoteBound === "true") {
      return;
    }

    if (
      window.matchMedia("(max-width: 767px)").matches ||
      !window.matchMedia("(hover: hover) and (pointer: fine)").matches
    ) {
      return;
    }

    var notes = productWrap.querySelectorAll(".launch-flavors__note[data-flavor]");
    var triggers = productWrap.querySelectorAll(
      ".launch-flavors__product-strip-wrap[data-flavor], .launch-flavors__product-strip[data-flavor], .launch-flavors__product-image, .launch-flavors__product-placeholder"
    );

    if (!notes.length || !triggers.length) {
      return;
    }

    productWrap.dataset.flavorsCursorNoteBound = "true";
    productWrap.classList.add("js-note-follow");

    var noteByFlavor = {};
    var activeFlavor = "";
    var followRafId = 0;
    var targetPosition = null;
    var currentPosition = null;
    var pointerOffsetX = 18;
    var pointerOffsetY = 18;
    var followEase = 0.22;

    notes.forEach(function (note) {
      var flavor = note.getAttribute("data-flavor");
      if (flavor) {
        noteByFlavor[flavor] = note;
      }
    });

    function clearActiveFlavor() {
      notes.forEach(function (note) {
        note.classList.remove("is-note-active");
      });
      activeFlavor = "";
    }

    function setActiveFlavor(flavor) {
      if (!noteByFlavor[flavor]) {
        flavor = "right";
      }
      if (!noteByFlavor[flavor]) {
        return false;
      }
      if (activeFlavor === flavor) {
        return true;
      }

      clearActiveFlavor();
      noteByFlavor[flavor].classList.add("is-note-active");
      activeFlavor = flavor;
      return true;
    }

    function getActiveNote() {
      return activeFlavor ? noteByFlavor[activeFlavor] : null;
    }

    function computeTargetPosition(clientX, clientY) {
      var note = getActiveNote();
      if (!(note instanceof HTMLElement)) {
        return null;
      }

      var wrapRect = productWrap.getBoundingClientRect();
      var noteRect = note.getBoundingClientRect();

      // Default anchor: cursor sits on note's bottom-left corner.
      var viewportX = clientX + pointerOffsetX;
      var viewportY = clientY - noteRect.height - pointerOffsetY;

      // Keep popup inside viewport when possible, but allow overflow
      // outside the product wrapper boundaries.
      if (viewportX + noteRect.width > window.innerWidth) {
        viewportX = clientX - noteRect.width - pointerOffsetX;
      }
      if (viewportX < 0) {
        viewportX = clientX + pointerOffsetX;
      }

      if (viewportY < 0) {
        viewportY = clientY + pointerOffsetY;
      }
      if (viewportY + noteRect.height > window.innerHeight) {
        viewportY = clientY - noteRect.height - pointerOffsetY;
      }

      return {
        x: viewportX - wrapRect.left,
        y: viewportY - wrapRect.top
      };
    }

    function applyPosition(x, y) {
      productWrap.style.setProperty("--launch-flavors-note-x", x + "px");
      productWrap.style.setProperty("--launch-flavors-note-y", y + "px");
    }

    function followStep() {
      followRafId = 0;

      if (!targetPosition || !currentPosition) {
        return;
      }

      var dx = targetPosition.x - currentPosition.x;
      var dy = targetPosition.y - currentPosition.y;

      currentPosition.x += dx * followEase;
      currentPosition.y += dy * followEase;

      if (Math.abs(dx) < 0.35 && Math.abs(dy) < 0.35) {
        currentPosition.x = targetPosition.x;
        currentPosition.y = targetPosition.y;
      }

      applyPosition(currentPosition.x, currentPosition.y);

      if (
        productWrap.classList.contains("is-note-visible") &&
        (Math.abs(targetPosition.x - currentPosition.x) > 0.2 || Math.abs(targetPosition.y - currentPosition.y) > 0.2)
      ) {
        followRafId = window.requestAnimationFrame(followStep);
      }
    }

    function ensureFollowLoop() {
      if (followRafId) {
        return;
      }

      followRafId = window.requestAnimationFrame(followStep);
    }

    function updateTarget(clientX, clientY) {
      var nextPosition = computeTargetPosition(clientX, clientY);
      if (!nextPosition) {
        return;
      }

      targetPosition = nextPosition;

      if (!currentPosition) {
        currentPosition = {
          x: nextPosition.x,
          y: nextPosition.y
        };
        applyPosition(currentPosition.x, currentPosition.y);
      }

      ensureFollowLoop();
    }

    function getFlavorFromTarget(target) {
      if (!(target instanceof Element)) {
        return "";
      }

      var trigger = target.closest(".launch-flavors__product-strip-wrap[data-flavor], .launch-flavors__product-strip[data-flavor]");
      if (trigger instanceof Element) {
        return trigger.getAttribute("data-flavor") || "";
      }

      return "right";
    }

    function handlePointerMove(event) {
      var flavor = getFlavorFromTarget(event.target);
      if (!setActiveFlavor(flavor)) {
        return;
      }

      productWrap.classList.add("is-note-visible");
      updateTarget(event.clientX, event.clientY);
    }

    function hideNote() {
      productWrap.classList.remove("is-note-visible");
      clearActiveFlavor();

      if (followRafId) {
        window.cancelAnimationFrame(followRafId);
      }
      followRafId = 0;
      targetPosition = null;
      currentPosition = null;
    }

    triggers.forEach(function (trigger) {
      trigger.addEventListener("pointerenter", handlePointerMove);
      trigger.addEventListener("pointermove", handlePointerMove);
    });
    productWrap.addEventListener("pointerleave", hideNote);
    productWrap.addEventListener("pointercancel", hideNote);
  }

  function initFlavorsCursorNotes(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var productWraps = root.querySelectorAll(".launch-flavors__product-wrap");

    productWraps.forEach(function (productWrap) {
      bindFlavorsCursorNote(productWrap);
    });
  }

  function parseJsonAttribute(value) {
    if (!value || typeof value !== "string") {
      return null;
    }

    try {
      return JSON.parse(value);
    } catch (error) {
      var decodedValue = value;
      if (decodedValue.indexOf("&") !== -1) {
        var decoder = document.createElement("textarea");
        decoder.innerHTML = decodedValue;
        decodedValue = decoder.value;
      }

      try {
        return JSON.parse(decodedValue);
      } catch (innerError) {
        return null;
      }
    }
  }

  function createSocialProofModalVideo(sources, posterUrl) {
    if (!Array.isArray(sources) || !sources.length) {
      return null;
    }

    var video = document.createElement("video");
    video.className = "launch-social-proof__modal-player";
    video.controls = true;
    video.autoplay = true;
    video.preload = "metadata";
    video.playsInline = true;
    video.setAttribute("playsinline", "true");

    if (posterUrl) {
      video.poster = posterUrl;
    }

    for (var i = 0; i < sources.length; i += 1) {
      var sourceData = sources[i];
      if (!sourceData || typeof sourceData !== "object") {
        continue;
      }

      var sourceUrl = sourceData.url;
      if (!sourceUrl || typeof sourceUrl !== "string") {
        continue;
      }

      var source = document.createElement("source");
      source.src = sourceUrl;

      if (sourceData.mime_type && typeof sourceData.mime_type === "string") {
        source.type = sourceData.mime_type;
      }

      video.appendChild(source);
    }

    if (!video.querySelector("source")) {
      return null;
    }

    return video;
  }

  function getYouTubeVideoId(parsedUrl) {
    if (!(parsedUrl instanceof URL)) {
      return "";
    }

    var host = parsedUrl.hostname.replace(/^www\./, "");
    if (host === "youtu.be") {
      return parsedUrl.pathname.replace(/^\//, "").split("/")[0] || "";
    }

    if (!/youtube\.com$/.test(host)) {
      return "";
    }

    var urlId = parsedUrl.searchParams.get("v");
    if (urlId) {
      return urlId;
    }

    var segments = parsedUrl.pathname.split("/").filter(Boolean);
    if (!segments.length) {
      return "";
    }

    if (segments[0] === "embed" || segments[0] === "shorts" || segments[0] === "live") {
      return segments[1] || "";
    }

    return "";
  }

  function getVimeoVideoId(parsedUrl) {
    if (!(parsedUrl instanceof URL)) {
      return "";
    }

    var host = parsedUrl.hostname.replace(/^www\./, "");
    if (!/vimeo\.com$/.test(host)) {
      return "";
    }

    var segments = parsedUrl.pathname.split("/").filter(Boolean);
    for (var i = segments.length - 1; i >= 0; i -= 1) {
      if (/^\d+$/.test(segments[i])) {
        return segments[i];
      }
    }

    return "";
  }

  function createSocialProofModalIframe(src, title) {
    if (!src) {
      return null;
    }

    var iframe = document.createElement("iframe");
    iframe.className = "launch-social-proof__modal-iframe";
    iframe.src = src;
    iframe.title = title || "Video player";
    iframe.allow = "autoplay; fullscreen; picture-in-picture; encrypted-media";
    iframe.allowFullscreen = true;
    iframe.setAttribute("loading", "lazy");
    return iframe;
  }

  function createSocialProofModalFallback(url) {
    var wrapper = document.createElement("div");
    wrapper.className = "launch-social-proof__modal-fallback";
    var paragraph = document.createElement("p");
    paragraph.appendChild(document.createTextNode("Unable to embed this video. "));

    var link = document.createElement("a");
    link.href = url;
    link.target = "_blank";
    link.rel = "noopener noreferrer";
    link.textContent = "Open it in a new tab";

    paragraph.appendChild(link);
    paragraph.appendChild(document.createTextNode("."));
    wrapper.appendChild(paragraph);
    return wrapper;
  }

  function createSocialProofExternalPlayer(videoUrl, posterUrl) {
    if (!videoUrl || typeof videoUrl !== "string") {
      return null;
    }

    var parsedUrl = null;
    try {
      parsedUrl = new URL(videoUrl, window.location.href);
    } catch (error) {
      parsedUrl = null;
    }

    if (parsedUrl) {
      var youTubeId = getYouTubeVideoId(parsedUrl);
      if (youTubeId) {
        return createSocialProofModalIframe(
          "https://www.youtube.com/embed/" + encodeURIComponent(youTubeId) + "?autoplay=1&rel=0&playsinline=1",
          "YouTube video player"
        );
      }

      var vimeoId = getVimeoVideoId(parsedUrl);
      if (vimeoId) {
        return createSocialProofModalIframe(
          "https://player.vimeo.com/video/" + encodeURIComponent(vimeoId) + "?autoplay=1&title=0&byline=0&portrait=0",
          "Vimeo video player"
        );
      }

      if (/\.(mp4|webm|ogg)(\?|#|$)/i.test(parsedUrl.pathname)) {
        return createSocialProofModalVideo(
          [
            {
              url: parsedUrl.href,
              mime_type: ""
            }
          ],
          posterUrl
        );
      }
    }

    if (/\.(mp4|webm|ogg)(\?|#|$)/i.test(videoUrl)) {
      return createSocialProofModalVideo(
        [
          {
            url: videoUrl,
            mime_type: ""
          }
        ],
        posterUrl
      );
    }

    return createSocialProofModalFallback(videoUrl);
  }

  function createSocialProofLegacyMedia(trigger, posterUrl) {
    if (!(trigger instanceof HTMLElement)) {
      return null;
    }

    var card = trigger.closest(".launch-social-proof__card");
    if (!(card instanceof HTMLElement)) {
      return null;
    }

    var legacyInlineVideo = card.querySelector("video.launch-social-proof__video, video");
    if (legacyInlineVideo instanceof HTMLVideoElement) {
      var legacySources = [];
      var sourceNodes = legacyInlineVideo.querySelectorAll("source");
      for (var i = 0; i < sourceNodes.length; i += 1) {
        var sourceNode = sourceNodes[i];
        if (!(sourceNode instanceof HTMLSourceElement)) {
          continue;
        }

        if (!sourceNode.src) {
          continue;
        }

        legacySources.push({
          url: sourceNode.src,
          mime_type: sourceNode.type || ""
        });
      }

      if (!legacySources.length) {
        var fallbackSource = legacyInlineVideo.currentSrc || legacyInlineVideo.src || "";
        if (fallbackSource) {
          legacySources.push({
            url: fallbackSource,
            mime_type: ""
          });
        }
      }

      var legacyPoster = posterUrl || legacyInlineVideo.getAttribute("poster") || "";
      return createSocialProofModalVideo(legacySources, legacyPoster);
    }

    if (trigger instanceof HTMLAnchorElement && trigger.href) {
      return createSocialProofExternalPlayer(trigger.href, posterUrl);
    }

    var legacyLinkedCard = card.querySelector("a.launch-social-proof__media-link[href]");
    if (legacyLinkedCard instanceof HTMLAnchorElement && legacyLinkedCard.href) {
      return createSocialProofExternalPlayer(legacyLinkedCard.href, posterUrl);
    }

    return null;
  }

  function clearSocialProofModalContent(modal) {
    if (!(modal instanceof HTMLElement)) {
      return;
    }

    var modalBody = modal.querySelector("[data-social-proof-modal-body]");
    if (!(modalBody instanceof HTMLElement)) {
      return;
    }

    var videos = modalBody.querySelectorAll("video");
    for (var i = 0; i < videos.length; i += 1) {
      var video = videos[i];
      if (!(video instanceof HTMLVideoElement)) {
        continue;
      }
      video.pause();
      video.removeAttribute("src");
      while (video.firstChild) {
        video.removeChild(video.firstChild);
      }
      video.load();
    }

    var iframes = modalBody.querySelectorAll("iframe");
    for (var j = 0; j < iframes.length; j += 1) {
      iframes[j].setAttribute("src", "about:blank");
    }

    modalBody.innerHTML = "";
  }

  function closeActiveSocialProofModal(modalToClose) {
    var modal = null;
    if (modalToClose instanceof HTMLElement) {
      modal = modalToClose;
    } else if (activeSocialProofModal instanceof HTMLElement) {
      modal = activeSocialProofModal;
    }

    if (!(modal instanceof HTMLElement)) {
      return;
    }

    clearSocialProofModalContent(modal);
    modal.hidden = true;
    modal.classList.remove("is-open");

    if (activeSocialProofModal === modal) {
      if (activeSocialProofTrigger instanceof HTMLElement) {
        try {
          activeSocialProofTrigger.focus({ preventScroll: true });
        } catch (error) {
          activeSocialProofTrigger.focus();
        }
      }

      activeSocialProofModal = null;
      activeSocialProofTrigger = null;
    }

    syncLaunchModalBodyLock();
  }

  function openSocialProofModal(modal, trigger) {
    if (!(modal instanceof HTMLElement) || !(trigger instanceof HTMLElement)) {
      return;
    }

    if (activeSocialProofModal && activeSocialProofModal !== modal) {
      closeActiveSocialProofModal();
    }

    var modalBody = modal.querySelector("[data-social-proof-modal-body]");
    if (!(modalBody instanceof HTMLElement)) {
      return;
    }

    clearSocialProofModalContent(modal);

    var posterUrl = trigger.getAttribute("data-video-poster") || "";
    var directVideoSrc = trigger.getAttribute("data-video-src") || "";
    var directVideoMime = trigger.getAttribute("data-video-mime") || "";
    var sources = parseJsonAttribute(trigger.getAttribute("data-video-sources"));
    var externalVideoUrl = trigger.getAttribute("data-video-url") || "";
    var media = null;

    if (directVideoSrc) {
      media = createSocialProofModalVideo(
        [
          {
            url: directVideoSrc,
            mime_type: directVideoMime
          }
        ],
        posterUrl
      );
    }

    if (!(media instanceof HTMLElement) && Array.isArray(sources) && sources.length) {
      media = createSocialProofModalVideo(sources, posterUrl);
    }

    if (!(media instanceof HTMLElement) && externalVideoUrl) {
      media = createSocialProofExternalPlayer(externalVideoUrl, posterUrl);
    }

    if (!(media instanceof HTMLElement)) {
      media = createSocialProofLegacyMedia(trigger, posterUrl);
    }

    if (!(media instanceof HTMLElement)) {
      return;
    }

    modalBody.appendChild(media);
    modal.hidden = false;
    modal.classList.add("is-open");
    syncLaunchModalBodyLock();
    activeSocialProofModal = modal;
    activeSocialProofTrigger = trigger;

    if (media instanceof HTMLVideoElement) {
      var playPromise = media.play();
      if (playPromise && typeof playPromise.catch === "function") {
        playPromise.catch(function () {});
      }
    }
  }

  function bindSocialProofModal(section) {
    if (!(section instanceof HTMLElement)) {
      return;
    }

    var modal = section.querySelector("[data-social-proof-modal]");
    if (!(modal instanceof HTMLElement)) {
      return;
    }

    if (section.dataset.socialProofOpenDelegateBound !== "true") {
      section.dataset.socialProofOpenDelegateBound = "true";
      section.addEventListener("click", function (event) {
        if (!(event.target instanceof Element)) {
          return;
        }

        var trigger = event.target.closest("[data-social-proof-open], .launch-social-proof__media-link--video");
        if (!(trigger instanceof HTMLElement) || !section.contains(trigger)) {
          return;
        }

        event.preventDefault();
        openSocialProofModal(modal, trigger);
      });
    }

    var closeTargets = modal.querySelectorAll("[data-social-proof-close]");
    closeTargets.forEach(function (closeTarget) {
      if (!(closeTarget instanceof HTMLElement) || closeTarget.dataset.socialProofCloseBound === "true") {
        return;
      }

      closeTarget.dataset.socialProofCloseBound = "true";
      closeTarget.addEventListener("click", function (event) {
        event.preventDefault();
        closeActiveSocialProofModal(modal);
      });
    });
  }

  function bindSocialProofCarousel(carousel) {
    if (!(carousel instanceof HTMLElement)) {
      return;
    }

    if (carousel.dataset.carouselBound === "true") {
      return;
    }

    carousel.dataset.carouselBound = "true";

    var viewport = carousel.querySelector("[data-social-proof-viewport]");
    var track = carousel.querySelector("[data-social-proof-track]");
    if (!(viewport instanceof HTMLElement) || !(track instanceof HTMLElement)) {
      return;
    }

    var cards = track.querySelectorAll(".launch-social-proof__card");
    if (!cards.length) {
      return;
    }

    var controls = carousel.querySelector(".launch-social-proof__controls");
    var previousButton = carousel.querySelector("[data-social-proof-prev]");
    var nextButton = carousel.querySelector("[data-social-proof-next]");

    var visibleCount = Number.parseInt(carousel.getAttribute("data-visible-count"), 10);
    if (!Number.isFinite(visibleCount) || visibleCount < 1) {
      visibleCount = 3;
    }

    var carouselEnabled = carousel.getAttribute("data-carousel-enabled") === "true";
    var maxIndex = Math.max(0, cards.length - visibleCount);
    var canSlide = carouselEnabled && maxIndex > 0;
    var currentIndex = 0;
    var cardWidth = 0;
    var cardGap = 0;

    var swipePointerId = null;
    var swipeStartX = 0;
    var swipeStartY = 0;
    var swipeDeltaX = 0;
    var swipeTracking = false;
    var swipeHorizontal = false;

    function updateButtons() {
      if (controls instanceof HTMLElement) {
        controls.hidden = !canSlide;
      }

      if (previousButton instanceof HTMLButtonElement) {
        previousButton.disabled = !canSlide || currentIndex <= 0;
      }

      if (nextButton instanceof HTMLButtonElement) {
        nextButton.disabled = !canSlide || currentIndex >= maxIndex;
      }
    }

    function updateTrackPosition() {
      if (!canSlide) {
        track.style.transform = "translate3d(0, 0, 0)";
        updateButtons();
        return;
      }

      var offset = currentIndex * (cardWidth + cardGap);
      track.style.transform = "translate3d(" + offset * -1 + "px, 0, 0)";
      updateButtons();
    }

    function goTo(index) {
      if (!canSlide) {
        return;
      }

      currentIndex = clamp(index, 0, maxIndex);
      updateTrackPosition();
    }

    function measure() {
      var firstCard = cards[0];
      if (!(firstCard instanceof HTMLElement)) {
        return;
      }

      cardWidth = firstCard.getBoundingClientRect().width;
      var trackStyles = window.getComputedStyle(track);
      cardGap = Number.parseFloat(trackStyles.columnGap || trackStyles.gap || "0");
      if (!Number.isFinite(cardGap)) {
        cardGap = 0;
      }

      if (currentIndex > maxIndex) {
        currentIndex = maxIndex;
      }

      updateTrackPosition();
    }

    function resetSwipeState() {
      swipePointerId = null;
      swipeStartX = 0;
      swipeStartY = 0;
      swipeDeltaX = 0;
      swipeTracking = false;
      swipeHorizontal = false;
    }

    function handlePointerDown(event) {
      if (!canSlide) {
        return;
      }

      if (event.pointerType !== "touch") {
        return;
      }

      swipePointerId = event.pointerId;
      swipeStartX = event.clientX;
      swipeStartY = event.clientY;
      swipeDeltaX = 0;
      swipeTracking = true;
      swipeHorizontal = false;
    }

    function handlePointerMove(event) {
      if (!swipeTracking || event.pointerId !== swipePointerId) {
        return;
      }

      swipeDeltaX = event.clientX - swipeStartX;
      var deltaY = event.clientY - swipeStartY;

      if (!swipeHorizontal) {
        if (Math.abs(swipeDeltaX) < 12) {
          return;
        }

        if (Math.abs(swipeDeltaX) <= Math.abs(deltaY)) {
          resetSwipeState();
          return;
        }

        swipeHorizontal = true;
      }

      event.preventDefault();
    }

    function handlePointerUp(event) {
      if (!swipeTracking || event.pointerId !== swipePointerId) {
        return;
      }

      if (swipeHorizontal) {
        if (swipeDeltaX <= -44) {
          goTo(currentIndex + 1);
        } else if (swipeDeltaX >= 44) {
          goTo(currentIndex - 1);
        }
      }

      resetSwipeState();
    }

    if (previousButton instanceof HTMLButtonElement) {
      previousButton.addEventListener("click", function () {
        goTo(currentIndex - 1);
      });
    }

    if (nextButton instanceof HTMLButtonElement) {
      nextButton.addEventListener("click", function () {
        goTo(currentIndex + 1);
      });
    }

    viewport.addEventListener("pointerdown", handlePointerDown);
    viewport.addEventListener("pointermove", handlePointerMove);
    viewport.addEventListener("pointerup", handlePointerUp);
    viewport.addEventListener("pointercancel", handlePointerUp);
    viewport.addEventListener("pointerleave", handlePointerUp);

    window.addEventListener("resize", measure);

    measure();
    updateButtons();
  }

  function closeActiveFlavorsFactsModal(modalToClose) {
    var modal = null;
    if (modalToClose instanceof HTMLElement) {
      modal = modalToClose;
    } else if (activeFlavorsFactsModal instanceof HTMLElement) {
      modal = activeFlavorsFactsModal;
    }

    if (!(modal instanceof HTMLElement)) {
      return;
    }

    modal.hidden = true;
    modal.classList.remove("is-open");

    if (activeFlavorsFactsModal === modal) {
      if (activeFlavorsFactsTrigger instanceof HTMLElement) {
        try {
          activeFlavorsFactsTrigger.focus({ preventScroll: true });
        } catch (error) {
          activeFlavorsFactsTrigger.focus();
        }
      }

      activeFlavorsFactsModal = null;
      activeFlavorsFactsTrigger = null;
    }

    syncLaunchModalBodyLock();
  }

  function openFlavorsFactsModal(modal, trigger) {
    if (!(modal instanceof HTMLElement) || !(trigger instanceof HTMLElement)) {
      return;
    }

    if (activeSocialProofModal instanceof HTMLElement) {
      closeActiveSocialProofModal();
    }
    if (activeFlavorsFactsModal && activeFlavorsFactsModal !== modal) {
      closeActiveFlavorsFactsModal();
    }

    var flavorTarget = modal.querySelector("[data-flavors-facts-flavor]");
    var descriptionTarget = modal.querySelector("[data-flavors-facts-description]");
    var fieldTargets = modal.querySelectorAll("[data-facts-field]");

    var flavorName = trigger.getAttribute("data-facts-flavor") || "Flavor";
    var descriptionText = trigger.getAttribute("data-facts-description") || "";
    var overrides = parseJsonAttribute(trigger.getAttribute("data-facts-overrides"));
    if (!overrides || typeof overrides !== "object" || Array.isArray(overrides)) {
      overrides = {};
    }

    if (flavorTarget instanceof HTMLElement) {
      flavorTarget.textContent = flavorName;
    }

    fieldTargets.forEach(function (fieldTarget) {
      if (!(fieldTarget instanceof HTMLElement)) {
        return;
      }

      var fieldKey = fieldTarget.getAttribute("data-facts-field");
      if (!fieldKey) {
        return;
      }

      if (!fieldTarget.dataset.factsDefaultText) {
        fieldTarget.dataset.factsDefaultText = fieldTarget.textContent || "";
      }

      var overrideValue = overrides[fieldKey];
      if (typeof overrideValue === "number") {
        overrideValue = String(overrideValue);
      }
      if (typeof overrideValue === "string" && overrideValue.trim().length) {
        fieldTarget.textContent = overrideValue;
        return;
      }

      fieldTarget.textContent = fieldTarget.dataset.factsDefaultText || "";
    });

    if (descriptionTarget instanceof HTMLElement) {
      var defaultDescription = descriptionTarget.getAttribute("data-default-description") || "";
      var resolvedDescription = descriptionText || defaultDescription;
      descriptionTarget.textContent = resolvedDescription;
      descriptionTarget.hidden = !resolvedDescription;
    }

    modal.hidden = false;
    modal.classList.add("is-open");
    activeFlavorsFactsModal = modal;
    activeFlavorsFactsTrigger = trigger;
    syncLaunchModalBodyLock();
  }

  function bindFlavorsFactsModal(flavorsSection) {
    if (!(flavorsSection instanceof HTMLElement)) {
      return;
    }

    var modal = flavorsSection.querySelector("[data-flavors-facts-modal]");
    if (!(modal instanceof HTMLElement)) {
      return;
    }

    if (modal.dataset.flavorsFactsPortaled !== "true") {
      modal.dataset.flavorsFactsPortaled = "true";
      document.body.appendChild(modal);
    }

    if (flavorsSection.dataset.flavorsFactsOpenDelegateBound !== "true") {
      flavorsSection.dataset.flavorsFactsOpenDelegateBound = "true";
      flavorsSection.addEventListener("click", function (event) {
        if (!(event.target instanceof Element)) {
          return;
        }

        var trigger = event.target.closest("[data-flavors-facts-open]");
        if (!(trigger instanceof HTMLElement) || !flavorsSection.contains(trigger)) {
          var stripTrigger = event.target.closest(".launch-flavors__product-strip-wrap[data-flavor], .launch-flavors__product-strip[data-flavor]");
          if (stripTrigger instanceof Element && flavorsSection.contains(stripTrigger)) {
            var flavorKey = stripTrigger.getAttribute("data-flavor") || "";
            if (flavorKey) {
              var mappedTrigger = flavorsSection.querySelector(
                '[data-flavors-facts-open][data-facts-key="' + flavorKey + '"]'
              );
              if (mappedTrigger instanceof HTMLElement) {
                trigger = mappedTrigger;
              }
            }
          }
        }

        if (!(trigger instanceof HTMLElement)) {
          return;
        }

        event.preventDefault();
        openFlavorsFactsModal(modal, trigger);
      });
    }

    var closeTargets = modal.querySelectorAll("[data-flavors-facts-close]");
    closeTargets.forEach(function (closeTarget) {
      if (!(closeTarget instanceof HTMLElement) || closeTarget.dataset.flavorsFactsCloseBound === "true") {
        return;
      }

      closeTarget.dataset.flavorsFactsCloseBound = "true";
      closeTarget.addEventListener("click", function (event) {
        event.preventDefault();
        closeActiveFlavorsFactsModal(modal);
      });
    });
  }

  function initFlavorsFactsModals(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var flavorsSections = [];
    if (root instanceof Element && root.matches(".launch-flavors")) {
      flavorsSections.push(root);
    }
    var nestedFlavorsSections = root.querySelectorAll(".launch-flavors");
    nestedFlavorsSections.forEach(function (section) {
      flavorsSections.push(section);
    });

    flavorsSections.forEach(function (section) {
      bindFlavorsFactsModal(section);
    });
  }

  function initSocialProofComponents(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var socialProofSections = [];
    if (root instanceof Element && root.matches(".launch-social-proof")) {
      socialProofSections.push(root);
    }
    var nestedSocialProofSections = root.querySelectorAll(".launch-social-proof");
    nestedSocialProofSections.forEach(function (section) {
      socialProofSections.push(section);
    });

    socialProofSections.forEach(function (section) {
      bindSocialProofModal(section);
    });

    var socialProofCarousels = [];
    if (root instanceof Element && root.matches("[data-social-proof-carousel]")) {
      socialProofCarousels.push(root);
    }
    var nestedSocialProofCarousels = root.querySelectorAll("[data-social-proof-carousel]");
    nestedSocialProofCarousels.forEach(function (carousel) {
      socialProofCarousels.push(carousel);
    });

    socialProofCarousels.forEach(function (carousel) {
      bindSocialProofCarousel(carousel);
    });
  }

  document.addEventListener("keydown", function (event) {
    if (!event || event.key !== "Escape") {
      return;
    }
    closeActiveSocialProofModal();
    closeActiveFlavorsFactsModal();
  });

  document.addEventListener("submit", function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) {
      return;
    }

    if (!form.classList.contains("js-launch-email-form")) {
      return;
    }

    var emailInput = form.querySelector('input[name="contact[email]"]');
    if (!(emailInput instanceof HTMLInputElement)) {
      return;
    }

    if (!isValidEmail(emailInput.value)) {
      event.preventDefault();
      emailInput.focus();
      showClientError(form, "Please enter a valid email address.");
      setSubmitState(form, false);
      return;
    }

    subscribeEmailToKlaviyoWaitlist(form, emailInput.value);
    showClientError(form, "");
    setSubmitState(form, true);
  });

  window.addEventListener("pageshow", function () {
    var submittingForms = document.querySelectorAll(".js-launch-email-form.is-submitting");
    submittingForms.forEach(function (form) {
      setSubmitState(form, false);
    });
  });

  initLoadingScreen();
  initViewportReveals(document);
  initSocialProofComponents(document);
  initFlavorsFactsModals(document);
  initFlavorsStaggerIntro(document);
  initHeroOceanScroll(document);
  initFlavorsGroundScroll(document);
  initFlavorsBackgroundLayout(document);
  initFlavorsCursorNotes(document);

  document.addEventListener("shopify:section:load", function (event) {
    if (!(event.target instanceof Element)) {
      return;
    }

    initViewportReveals(event.target);
    initSocialProofComponents(event.target);
    initFlavorsFactsModals(event.target);
    initFlavorsStaggerIntro(event.target);
    initHeroOceanScroll(event.target);
    initFlavorsGroundScroll(event.target);
    initFlavorsBackgroundLayout(event.target);
    initFlavorsCursorNotes(event.target);
  });
})();
